import React, { Component } from "react";
import { Row, Col, Button, Tooltip } from "reactstrap";
import SvgIcon from "react-icons-kit";
import { plus } from "react-icons-kit/icomoon/plus";
import * as extensionImage from "../../images/FileTypes";
import { processFileExtension } from "../Common/helperFunctions";
import { getServerEndpoint } from "utils/serverEndpoint";
import { languageService } from "../../Language/language.service";
import { themeService } from "../../theme/service/activeTheme.service";
import { basicColors, retroColors, electricColors } from "../../style/basic/basicColors";
import { fetchStaticResource, sanitizedFilename } from "../../utils/utils";
import { cross } from "react-icons-kit/icomoon/cross";

class DocumentsArea extends Component {
  state = {
    documentUrls: {},
  };

  async fetchDocumentUrls() {
    const documentUrls = {};
    const { documentList, path } = this.props;
    const endpoint = getServerEndpoint();

    for (const doc of documentList) {
      const sanitizedDoc = sanitizedFilename(doc);
      documentUrls[doc] = await fetchStaticResource(`${endpoint}${path}/${sanitizedDoc}`);
    }

    this.setState({ documentUrls });
  }

  componentDidMount() {
    this.fetchDocumentUrls();
  }

  renderDocuments = (documents) =>
    documents.map((doc, index) => {
      const { documentUrls } = this.state;
      if (doc && documentUrls[doc]) {
        return (
          <div
            style={{ display: "inline-block", margin: "0 3% 0 0", cursor: "pointer", fontSize: "12px", width: "44px" }}
            key={doc + index}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <a href={documentUrls[doc]} download={doc} target={"_blank"}>
                <DocumentComp
                  index={index}
                  docName={doc}
                  borderStyle={themeService({
                    default: "1px solid" + basicColors.first,
                    retro: "0px solid " + "var(--second)",
                    electric: "0px solid " + electricColors.second,
                  })}
                  width={"100%"}
                />
              </a>
              {this.props.allowDeletion && (
                <SvgIcon
                  icon={cross}
                  size={18}
                  style={{ marginLeft: "auto", marginRight: "auto", display: "block", cursor: "pointer", color: "#840F0F" }}
                  onClick={() => {
                    this.props.deleteDocument && this.props.deleteDocument(doc, index);
                  }}
                />
              )}
            </div>
          </div>
        );
      }
      return null;
    });

  render() {
    let documentList = this.props.documentList;

    return (
      <Row>
        <Col md={12}>
          <h5
            style={themeService({
              default: { padding: "10px 0px", font: "18px sans-serif", color: "var(--first)" },
              retro: { padding: "10px 0px", font: "18px sans-serif", color: "var(--second)" },
              electric: { padding: "10px 0px", font: "18px sans-serif", color: electricColors.second },
            })}
          >
            {languageService("Documents")}
          </h5>
        </Col>
        {this.props.acctionBtn ? (
          <React.Fragment>
            <Col md={10}>
              <div
                className="scrollbarHor"
                style={{
                  display: "grid",
                  gridAutoFlow: "column",
                  gridTemplateRows: "repeat(2, 1fr)",
                  gap: "10px",
                  overflow: "scroll",
                }}
              >
                {this.renderDocuments(documentList)}
              </div>
            </Col>

            <Col md={2} style={{ padding: "0px" }}>
              <div
                style={themeService({
                  default: { padding: "15px 0px", margin: "auto", width: "50%", color: "var(--first)", cursor: "pointer" },
                  retro: { padding: "15px 0px", margin: "auto", width: "50%", color: "var(--second)", cursor: "pointer" },
                  electric: { padding: "15px 0px", margin: "auto", width: "50%", color: electricColors.second, cursor: "pointer" },
                })}
              >
                <SvgIcon onClick={this.props.addDocument} icon={plus} size={20} />
              </div>
            </Col>
          </React.Fragment>
        ) : (
          <Col md={12}>
            <div
              className="scrollbarHor"
              style={{
                display: "grid",
                gridAutoFlow: "column",
                gridTemplateRows: "repeat(2, 1fr)",
                gap: "10px",
                overflow: "scroll",
              }}
            >
              {this.renderDocuments(documentList)}
            </div>
          </Col>
        )}
      </Row>
    );
  }
}

export default DocumentsArea;

class DocumentComp extends Component {
  state = {
    tooltip: null,
  };

  toggleTooltip = (tooltip) => {
    if (this.state.tooltip) {
      this.setState({ tooltip: null });
    } else {
      this.setState({ tooltip });
    }
  };

  render() {
    let [documentName, extension] = this.props.docName.split(".");

    extension = processFileExtension(this.props.docName);

    return (
      <div
        id={`doc_${this.props.index + 1}`}
        style={{ padding: "5px 5px", border: this.props.borderStyle ? this.props.borderStyle : "3px solid var(--first)" }}
      >
        <img
          src={extensionImage[extension]}
          style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: "40px" }}
          alt={extension}
          onClick={this.props.onClick}
        />

        {/* <Tooltip style={{marginRight:'40px'}}
                    isOpen={this.state.tooltip !== null && this.state.tooltip === this.props.index + 1}
                    target={`doc_${this.props.index + 1}`}
                    toggle={() => this.toggleTooltip(this.props.index + 1)}
                    placement={"top"}
                    onClick={this.props.onClick}
                >
                    {documentName}
                </Tooltip> */}
        {/*<div>*/}
        {/*{documentName}*/}
        {/*</div>*/}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/documentsArea.jsx